import { render, staticRenderFns } from "./PrevNextNav.vue?vue&type=template&id=609ba356&scoped=true&"
import script from "./PrevNextNav.vue?vue&type=script&lang=js&"
export * from "./PrevNextNav.vue?vue&type=script&lang=js&"
import style0 from "./PrevNextNav.vue?vue&type=style&index=0&id=609ba356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ba356",
  null
  
)

export default component.exports